export  default {
    appName: "ESchool",
    appTitle: "ESchool",
    dateFormat: "yyyy-MM-dd",
}
export const CONSTANT_CONFIG = {
    SAMPLE: "SAMPLE",
    // DATA_WAREHOUSE_API_URL : "http://localhost:7295/",
    // DATA_WAREHOUSE_API_URL : "http://localhost:7295/",
    // DATA_WAREHOUSE_API_URL : "http://10.5.10.46/",
    // DATA_WAREHOUSE_API_URL : "http://localhost:8000/"  ,
    // DATA_WAREHOUSE_API_URL : "http://192.168.1.12:8000/"   ,
    DATA_WAREHOUSE_API_URL : "https://api.crms.aau.edu.et/",
    CBI_API_URL: 'http://api.apmas.aau.edu.et/',
    // CBI_API_URL: 'http://10.6.56.237:5000/',
    // CBI_API_URL: 'http://192.168.137.1:5000/',
}
export const LOCAL_STORAGE_KEYS = {
    ACCESS_TOKEN: '0t@712$vr#bg'
}

